import { useEffect,  useState } from 'react';
import { getNotifications, markNotificationAsRead } from './utils/notifications';

function useUserNotification(page=1) {
  const [notifications, setNotifications] = useState([]);
  const [notificationsLoaded, setNotificationsLoaded] = useState(false);
  const [pagination, setPagination] = useState({
    next:false,
    previous:false,
    current:page
  })


  useEffect(() => {
      setNotificationsLoaded(false)
      getNotifications({page}, (data) => {
        setPagination({
          next:data?.next,
          previous:data?.previous,
          current:page
        })
        setNotifications(data?.results);
        setNotificationsLoaded(true);
      },);
   
  }, [page]);

  const handleCloseNotification = (id) => {
    markNotificationAsRead(
      {
        notification_id: id,
        status: 'READ',
      },
      (err, data, response) => {
        console.log(err, data, response, 'Marking as read:', id);
      }
    );
  }

  return {handleCloseNotification, notifications, notificationsLoaded, setNotifications, setNotificationsLoaded, pagination };
}

export default useUserNotification;
